import React from 'react';
import PropTypes from 'prop-types';
import userProp from '../../../commonComponents/propTypes/userProp';
import { displayUserName } from '../../../services/utilityFunctions';

export default function OrderUserInfo({ user }) {
  return (
    <div className="order-details-user-info">
      <img src={user?.image?.thumb || '/images/no_user.png'} alt="seller" />
      <div className="order-details-user-name-and-phone">
        <div className="order-details-user-name">{displayUserName(user)}</div>
        {!!user.phone && (
          <div className="order-details-user-phone">{user?.phone}</div>
        )}
      </div>
    </div>
  );
}

OrderUserInfo.propTypes = {
  user: PropTypes.shape(userProp.propType).isRequired,
};
